// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimRepaymentDto
 */
export interface IClaimRepaymentDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentDto
     */
    claim_id: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentDto
     */
    repayment_amount: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimRepaymentDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimRepaymentDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimRepaymentDto
     */
    status?: IClaimRepaymentDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IClaimRepaymentDtoStatusEnum {
    CREATED = 'CREATED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED'
}


/**
 * Check if a given object implements the IClaimRepaymentDto interface.
 */
export function instanceOfIClaimRepaymentDto(value: object): value is IClaimRepaymentDto {
    if (!('claim_id' in value) || value['claim_id'] === undefined) return false;
    if (!('repayment_amount' in value) || value['repayment_amount'] === undefined) return false;
    return true;
}

export function IClaimRepaymentDtoFromJSON(json: any): IClaimRepaymentDto {
    return IClaimRepaymentDtoFromJSONTyped(json, false);
}

export function IClaimRepaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimRepaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'],
        'repayment_amount': json['repayment_amount'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function IClaimRepaymentDtoToJSON(json: any): IClaimRepaymentDto {
    return IClaimRepaymentDtoToJSONTyped(json, false);
}

export function IClaimRepaymentDtoToJSONTyped(value?: IClaimRepaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'repayment_amount': value['repayment_amount'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'status': value['status'],
    };
}

